import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { apiErrorMessage } from '../core/api-error';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { PaginationResult } from '../core/pagination';
import {
  CreateReferrerRequest,
  Referrer,
  UpdateReferrerRequest,
} from '../models';

@Injectable({ providedIn: 'root' })
export class AdminReferrersApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).crmApiBaseUrl}/api/admin/BackofficeReferrers`;

  getReferrers(options?: { search?: string; skip?: number; take?: number }) {
    let params = new HttpParams();

    if (options?.search) {
      params = params.append('search', options.search);
    }

    if (options?.skip !== null && options?.skip !== undefined) {
      params = params.append('skip', options.skip);
    }

    if (options?.take !== null && options?.take !== undefined) {
      params = params.append('take', options.take);
    }

    return this.httpClient.get<PaginationResult<Referrer>>(`${this.baseUrl}`, {
      params,
    });
  }

  getReferrer(id: string) {
    return this.httpClient.get<Referrer>(`${this.baseUrl}/${id}`);
  }

  createReferrer(dto: CreateReferrerRequest) {
    return this.httpClient.post<{ id: string }>(`${this.baseUrl}`, dto).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(error, {
            AlreadyExists:
              "L'indirizzo email è già in uso da un altro referente.",
          }),
        ),
      ),
    );
  }

  updateReferrer(dto: UpdateReferrerRequest) {
    return this.httpClient.put<void>(`${this.baseUrl}`, dto).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(error, {
            AlreadyExists:
              "L'indirizzo email è già in uso da un altro referente.",
            NotFound: 'Il referente non esiste più.',
          }),
        ),
      ),
    );
  }

  deleteReferrer(id: string) {
    return this.httpClient.delete<void>(`${this.baseUrl}/${id}`).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(
            error,
            {
              Generic:
                'Impossibile eliminare il referente: è collegato ad almeno un contatto.',
              NotFound: 'Il referente non esiste più.',
            },
            "Impossibile eliminare il referente. Riprova più tardi o contatta l'assistenza tecnica.",
          ),
        ),
      ),
    );
  }
}
